import { Schema } from "effect"

export const Id = Schema.String.pipe(Schema.brand("@superwall/onesignal/OneSignalPlayerId/Id"))
